// extracted by mini-css-extract-plugin
export default {"container":"Film_container__COZxZ","tabs":"Film_tabs__CtW5l","tab":"Film_tab__-X2q7","activeTab":"Film_activeTab__i8Tbg","content":"Film_content__3pZ+H"};